export const galleryImages = [
  {
    id: 1,
    image: "/images/olive (1).jpeg",
    alt: "Olive Dental Clinic gallery image 1",
    title: "Olive Dental Clinic Gallery",
    category: "Gallery"
  },
  {
    id: 2,
    image: "/images/olive (2).jpeg",
    alt: "Olive Dental Clinic gallery image 2",
    title: "Olive Dental Clinic Gallery",
    category: "Gallery"
  },
  {
    id: 3,
    image: "/images/olive (3).jpeg",
    alt: "Olive Dental Clinic gallery image 3",
    title: "Olive Dental Clinic Gallery",
    category: "Gallery"
  },
  {
    id: 4,
    image: "/images/olive (4).jpeg",
    alt: "Olive Dental Clinic gallery image 4",
    title: "Olive Dental Clinic Gallery",
    category: "Gallery"
  },
  {
    id: 5,
    image: "/images/olive (5).jpeg",
    alt: "Olive Dental Clinic gallery image 5",
    title: "Olive Dental Clinic Gallery",
    category: "Gallery"
  },
  {
    id: 6,
    image: "/images/olive (6).jpeg",
    alt: "Olive Dental Clinic gallery image 6",
    title: "Olive Dental Clinic Gallery",
    category: "Gallery"
  },
  {
    id: 7,
    image: "/images/olive (7).jpeg",
    alt: "Olive Dental Clinic gallery image 7",
    title: "Olive Dental Clinic Gallery",
    category: "Gallery"
  },
  {
    id: 8,
    image: "/images/olive (8).jpeg",
    alt: "Olive Dental Clinic gallery image 8",
    title: "Olive Dental Clinic Gallery",
    category: "Gallery"
  }
];

// ============================================================
// HELPER FUNCTIONS
// ============================================================

// Get all gallery images
export const getAllGalleryImages = () => galleryImages;

// Get image by ID
export const getGalleryImageById = (id) =>
  galleryImages.find((img) => img.id === id);

// Get images by category
export const getGalleryImagesByCategory = (category) =>
  galleryImages.filter((img) => img.category === category);

// Get all categories
export const getAllGalleryCategories = () => {
  const categories = galleryImages.map((img) => img.category);
  return [...new Set(categories)];
};

// Get total image count
export const getGalleryCount = () => galleryImages.length;